import React, { useState } from "react";
import { assignForkliftService, getForkliftDriversService } from "../api/services/lift";
import handleMessages from "../utils/HandleMessages";

const useLift = () => {
  const [forkliftDrivers, setForkliftDrivers] = useState([]);

  const getForkliftDrivers = async () => {
    const res = await getForkliftDriversService();
    if (res.success) {
      setForkliftDrivers(res.data.response);
    }
  };

  const assignForklift = async (data) => {
    const res = await assignForkliftService(data)
    return handleMessages(res)
  }

  return {
    forkliftDrivers,
    getForkliftDrivers,
    assignForklift
  }
};

export default useLift;
